import axios from "axios";

const serverUrl = process.env.VUE_APP_URL;

export default {
    methods: {
        getCouverturesOnShelfByRecipeId(recipeId, limitToActive = false) {
            var url = `${serverUrl}Couverture/GetCouverturesOnShelfByRecipeId`;
            return axios
                .post(url, {recipeId: recipeId, limitToActive: limitToActive});
        },
        getCouvertures(page, itemsPerPage, productsFilter, searchTerm) {
            var url = `${serverUrl}Couverture/GetCouvertures`;
            return axios
                .post(url, {
                    page: page,
                    itemsPerPage: itemsPerPage,
                    productsFilter: productsFilter,
                    searchTerm: searchTerm,
                });
        },
        addCouvertureToMill(couvertureId, millId) {
            var url = `${serverUrl}Couverture/PutCouvertureToMill`;
            return axios
                .post(url, {
                    couvertureId,
                    millId
                })
        }
    },
};
